module.exports = __webpack_public_path__ + "resources/img/img_hacking_testing_m_jp.196b1b0c701e7815c66a4365e04546f5.png";